window.PXUTheme = window.PXUTheme || {};

window.PXUTheme.jsGlobalProduct = {
  async init() {
    this.watchSwappers(); // Watch for changes in variant
    if (document.querySelector("[data-product-selection]")) {
      this.watchInputs();
    }
    if (document.querySelector("[data-product-atc]")) {
      this.watchATCs();
    }
    if (document.querySelector(".global-product__atc-bar")) {
      this.watchATCScroll();
    }
    if (document.querySelectorAll("[data-sticky-selection]") && document.getElementById("getStartedBtn")) {
      this.updateFloatingATC();
    }
    this.updateKlarnaPrice();

    if (document.querySelectorAll("input[data-update-selected-variant]")) {
      this.watchSelectedVariantChanges();
    }

    if (document.body.getAttribute("data-intelligems-enabled") === "true") {
      this.initIntelligems();
    }

    this.outOfStockHandler(false);

    this.onLoadElements();
  },

  updateKlarnaPrice() {
    const klarnaEl = document.querySelector("klarna-placement");
    const priceEl = document.querySelector("[data-klarna-price]");

    if (klarnaEl && priceEl) {
      const price = Number(priceEl.dataset.klarnaPrice);

      if (price < 5000) {
        klarnaEl.classList.add("hidden");
      } else {
        klarnaEl.classList.remove("hidden");
      }

      klarnaEl.setAttribute("data-purchase-amount", price);

      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });

      klarnaEl.classList.add("Reveal");
    }
  },

  watchSelectedVariantChanges() {
    const selectedVariantInputs = document.querySelectorAll("input[data-update-selected-variant]");

    if (selectedVariantInputs.length === 0) {
      console.warn("No selected variant inputs found.");
      return;
    }

    selectedVariantInputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        const newVariant = event.target.value;
        document.querySelector("input[name='id']").value = newVariant;
      });
    });
  },

  watchDisabledBlocks() {
    const products = document.querySelectorAll("product");
    let enableDisabled = true;

    for (const prod of products) {
      if (!prod.querySelector("[data-product-selection]:checked")) {
        enableDisabled = false;
      }
    }

    if (enableDisabled) {
      const disabledBlocks = document.querySelectorAll("[data-product-disabled]");
      for (const block of disabledBlocks) {
        block.classList.add("enabled");
      }
    }
  },

  disableDisabledBlocks() {
    const disabledBlocks = document.querySelectorAll("[data-product-disabled]");
    for (const block of disabledBlocks) {
      block.classList.remove("enabled");
    }
  },

  // Watch inputs to show subscription options
  watchInputs() {
    const updateHandler = () => {
      const inputs = document.querySelectorAll("[data-product-selection]");
      if (document.querySelector(".global-product__options__subscription")) {
        document.querySelector(".global-product__options__subscription").classList.add("active");
      }
      this.watchDisabledBlocks();
      this.updatePricing(inputs);
    };

    document.addEventListener("change", (event) => {
      if (event.target.matches("[data-product-selection]")) {
        updateHandler();
      }
      this.outOfStockHandler(event);
    });
  },

  outOfStockHandler(event) {
    if(event) {
      const btn = document.querySelector("[data-product-atc]");
      if (btn) {
        if (event.target.matches("[data-out-of-stock='true']")) {
          btn.classList.add("disabled");
          btn.setAttribute("aria-disabled", "true");
          btn.textContent = "Out of stock";
        } else {
          btn.classList.remove("disabled");
          btn.setAttribute("aria-disabled", "false");
          btn.textContent = "Add to cart";
        }
      }

      const additionaPaymentContainer = document.querySelector(".global-product .additional_payment_container");
      if (additionaPaymentContainer) {
        if (event.target.matches("[data-out-of-stock='true']")) {
          additionaPaymentContainer.classList.add("hidden");
        } else {
          additionaPaymentContainer.classList.remove("hidden");
        }
      }
    } else {
      const inputs = document.querySelectorAll("[data-product-selection]");
      if (!inputs.length) return;

      let allOutOfStock = true;
      let checkedOutOfStock = false;

      for (const input of inputs) {
        const isOutOfStock = input.dataset.outOfStock === "true";

        if (!isOutOfStock) {
          allOutOfStock = false;
        }

        if (input.checked && isOutOfStock) {
          checkedOutOfStock = true;
        }
      }

      const disableButton = allOutOfStock || checkedOutOfStock;

      const btn = document.querySelector("[data-product-atc]");
      const additionalPaymentContainer = document.querySelector(".global-product .additional_payment_container");

      if (disableButton) {
        if (btn) {
          btn.classList.add("disabled");
          btn.setAttribute("aria-disabled", "true");
          btn.textContent = "Out of stock";
        }
        if (additionalPaymentContainer) additionalPaymentContainer.classList.add('hidden');
      }
    }
  },

  updatePricing(inputs) {
    let price = 0;
    let comparePrice = 0;
    let sellingPlan = false;

    for (const input of inputs) {
      if (input.checked == true) {
        if (input.dataset.quantity > 0) {
          price = Number(price) + Number(input.dataset.price * input.dataset.quantity);
          if (input.dataset.comparePrice && input.dataset.comparePrice > 0) {
            comparePrice = Number(comparePrice) + Number(input.dataset.comparePrice * input.dataset.quantity);
          } else {
            comparePrice = Number(comparePrice) + Number(input.dataset.price * input.dataset.quantity);
          }
        } else {
          price = Number(price) + Number(input.dataset.price);
          if (input.dataset.comparePrice && input.dataset.comparePrice > 0) {
            comparePrice = Number(comparePrice) + Number(input.dataset.comparePrice);
          } else {
            comparePrice = Number(comparePrice) + Number(input.dataset.price);
          }
        }
        if (input.dataset.sellingPlan) {
          sellingPlan = Number(input.dataset.price * input.dataset.quantity);
        }
      }
    }

    if (document.querySelector("[data-product-price-money]")) {
      const finalPrice = Shopify.formatMoney(price, document.body.getAttribute("data-money-format"));
      const finalComparePrice = comparePrice > 0 && comparePrice > price ? " <span>" + Shopify.formatMoney(comparePrice, document.body.getAttribute("data-money-format")) + "</span>" : "";
      document.querySelector("[data-product-price-money]").innerHTML = `<span>${finalPrice}</span>${finalComparePrice}`;
    }

    if (document.querySelector("[data-product-price-text]")) {
      document.querySelector("[data-product-price-text]").dataset.klarnaPrice = price;
    }

    if (sellingPlan && document.querySelector("[data-product-price-text]")) {
      const subscriptionPrice = Shopify.formatMoney(sellingPlan, document.body.getAttribute("data-money-format"));
      document.querySelector("[data-product-price-text]").innerHTML = `Your total today <span class="sub">+ ${subscriptionPrice} every 6 months</span>`;
    } else if (document.querySelector("[data-product-price-text]")) {
      document.querySelector("[data-product-price-text]").innerHTML = `Your total`;
    }

    // update global-product__price price
    if (document.querySelector(".global-product__price")) {
      const priceEl = document.querySelector(".global-product__price");
      const saleLabel = priceEl.querySelector(".slabel");
      const compareAtPriceEl = priceEl.querySelector(".compare-at-price");
      const salePriceWrapper = priceEl.querySelector(".sale_price-wrapper");
      const priceMoney = Shopify.formatMoney(price, document.body.getAttribute("data-money-format"));
      const compareAtMoney = comparePrice > 0 && comparePrice > price ? Shopify.formatMoney(comparePrice, document.body.getAttribute("data-money-format")) : null;

      if(priceEl.querySelector(".from_text")) {
        const fromText = priceEl.querySelector(".from_text");
        fromText.style.display = "none";
      }

      if (compareAtPriceEl && compareAtMoney) {
        compareAtPriceEl.textContent = compareAtMoney;
        compareAtPriceEl.style.display = "";
      } else if (compareAtPriceEl) {
        compareAtPriceEl.style.display = "none";
      }

      const priceSaleEl = priceEl.querySelector(".price--sale");
      if (priceSaleEl) {
        priceSaleEl.textContent = priceMoney;
      }

      if (saleLabel && comparePrice > price && comparePrice > 0) {
        const percentOff = Math.round(((comparePrice - price) / comparePrice) * 100);
        saleLabel.textContent = `${percentOff}% OFF`;
        saleLabel.style.display = "";
      } else if (saleLabel) {
        saleLabel.style.display = "none";
      }

      if (salePriceWrapper) {
        if (comparePrice > price && comparePrice > 0) {
          salePriceWrapper.style.display = "";
        } else {
          salePriceWrapper.style.display = "none";
        }
      }
    }

    this.updateKlarnaPrice();

    if(document.querySelector(".global-product .additional_payment_container") && document.querySelector(".global-product klarna-placement")) {
      const targetContainer = document.querySelector(".global-product .additional_payment_container");
      const klarnaEl = document.querySelector(".global-product klarna-placement");
      if (sellingPlan) {
        targetContainer.classList.add("hidden");
        klarnaEl.classList.add("hidden");
      } else {
        targetContainer.classList.remove("hidden");
        klarnaEl.classList.remove("hidden");
      }
    } else {
      console.log('Additional or klarna not found');
    }
  },

  // Watch for changes in variant selection and update gallery
  watchSwappers() {
    const variantSelectors = document.querySelectorAll("[data-swapper]");
    const swappableElements = document.querySelectorAll("[data-colour-swap]");

    if (variantSelectors.length === 0) {
      console.warn("No variant swappers found.");
      return;
    }

    variantSelectors.forEach((swapper) => {
      swapper.addEventListener("click", (event) => {
        const newVariant = event.target.dataset.swapper;
        this.updateGallerySwatches(event.target.dataset.swapper);
        if (swappableElements.length > 0) {
          for (const el of swappableElements) {
            const inputs = document.querySelectorAll("product input");
            for (const input of inputs) {
              if (!input.dataset.colour && input.checked) {
                input.checked = false; // Uncheck all radios
              }
              if (input.dataset.colour) {
                if (input.dataset.colour === newVariant && input.dataset.defaultOption == "true") {
                  input.checked = true;
                }
              }
            }
            if (el.dataset.colourSwap === newVariant) {
              el.classList.add("active");
            } else {
              el.classList.remove("active");
            }
          }
        } else {
          console.warn("No swappable elements found.");
        }
      });
    });
  },

  updateGallerySwatches(swapper) {
    if (document.querySelector(".gallery-swatches .gallery-swatch")) {
      if (document.querySelector(`.gallery-swatches .gallery-swatch.active`)) document.querySelector(`.gallery-swatches .gallery-swatch.active`).classList.remove("active");
      document.querySelector(`.gallery-swatches .gallery-swatch.swatch-${swapper}`).classList.add("active");
    }
  },

  watchATCs() {
    const addToCartButtons = document.querySelectorAll("[data-product-atc]");

    for (const btn of addToCartButtons) {
      // Remove previous click handlers to avoid duplicates
      btn.replaceWith(btn.cloneNode(true));
    }

    const freshButtons = document.querySelectorAll("[data-product-atc]");
    for (const btn of freshButtons) {
      btn.addEventListener("click", async (event) => {
        btn.classList.add("loading");

        let items = [];
        let addProducts = true;
        let sellingPlanParent = btn.dataset.sellingPlan;
        let parent = document;

        if(btn.closest(".global-product")) {
          parent = btn.closest(".global-product");
        }

        // Always get the latest quantity
        const quantity = parseInt(btn.getAttribute("data-quantity"), 10) || 1;

        // Loop through all products and build the cart items
        if (parent.querySelector(".global-product product")) {
          const products = parent.querySelectorAll(".global-product product");
          for (const p of products) {
            const variant = p.querySelector("[data-product-selection]:checked");

            let allowEmpty = false;
            if (p.dataset.allowEmpty) {
              allowEmpty = true;
            }

            // Skip if no variant is selected
            if (!variant && !allowEmpty) {
              p.scrollIntoView({ behavior: "smooth", block: "center" });
              p.classList.add("highlight");
              setTimeout(() => p.classList.remove("highlight"), 1000);
              addProducts = false;
              btn.classList.remove("loading");
              return;
            }

            if (variant) {
              let ids = variant.value.split(",");
              let sellingPlans = [];
              let sellingPlan = null;

              // Handle selling plans as a comma-separated list, synced with ids
              if (!sellingPlanParent) {
                if (variant.dataset.sellingPlan) {
                  sellingPlans = variant.dataset.sellingPlan.split(",");
                }
              } else {
                if (variant.dataset.sellingPlan) {
                  sellingPlans = variant.dataset.sellingPlan.split(",");
                } else {
                  sellingPlans = sellingPlanParent.split(",");
                }
              }

              // Handle quantities as a comma-separated list, synced with ids
              let quantities = [];
              if (variant.dataset.quantity) {
                quantities = variant.dataset.quantity.split(",");
              } else {
                // fallback to 1 for each id
                quantities = Array(ids.length).fill("1");
              }

              // If sellingPlans length matches ids, sync them up, else fallback to single sellingPlan for all
              let useSyncedSellingPlans = sellingPlans.length === ids.length;
              // If quantities length matches ids, sync them up, else fallback to single quantity for all
              let useSyncedQuantities = quantities.length === ids.length;

              // Check if the URL has the ?FREEWB parameter
              const urlParams = new URLSearchParams(window.location.search);
              const freeWBParam = urlParams.get("FREEWB");

              // If the parameter is set, store a cookie
              if (freeWBParam) {
                document.cookie = "FREEWB=true; path=/; max-age=" + 60 * 60 * 24 * 7; // Cookie valid for 7 days
              }

              // Check if the cookie is set
              const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
                const [key, value] = cookie.split("=");
                acc[key] = value;
                return acc;
              }, {});

              if (freeWBParam || cookies.FREEWB) {
                // Only check the first id for upsell logic
                const product = window.allProductUpsells.find((item) => item.id == ids[0]) ?? false;
                if (product && product.url.includes("suri-sustainable-sonic-toothbrush-uv-c-led-case")) {
                  const cartResponse = await fetch("/cart.js", {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                  });

                  if (cartResponse.ok) {
                    const cartData = await cartResponse.json();
                    const isItemInCart = cartData.items.some((item) => item.id === 55422926815611);

                    if (!isItemInCart) {
                      items.push({
                        id: 55422926815611,
                        quantity: 1,
                      });
                    }
                  }
                }
              }

              for (let i = 0; i < ids.length; i++) {
                const id = ids[i];
                if (id == "false") {
                  continue;
                }
                let itemSellingPlan = null;
                if (useSyncedSellingPlans) {
                  itemSellingPlan = sellingPlans[i] && sellingPlans[i] !== "null" && sellingPlans[i] !== "" ? sellingPlans[i] : null;
                } else if (sellingPlans.length > 0 && sellingPlans[0] !== "null" && sellingPlans[0] !== "") {
                  itemSellingPlan = sellingPlans[0];
                }
                let itemQuantity = 1;
                if (useSyncedQuantities) {
                  itemQuantity = parseInt(quantities[i], 10) || 1;
                } else if (quantities.length > 0 && quantities[0] !== "") {
                  itemQuantity = parseInt(quantities[0], 10) || 1;
                }
                items.push({
                  id,
                  quantity: itemQuantity,
                  ...(itemSellingPlan ? { selling_plan: itemSellingPlan } : {}),
                });
              }
            }
          }
        } else {
          const variantId = btn.dataset.defaultProduct;
          items.push({
            id: variantId,
            quantity: quantity,
          });
        }

        if (items.length === 0 || addProducts == false) return; // Exit if no items to add

        try {
          // Add items to cart
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) throw new Error("Failed to add to cart");

          window.PXUTheme.jsCart.updateCart();
          window.PXUTheme.jsCart.toggleCart("show");

          this.resetFloatingATC();
          this.clearInputs();
          this.disableDisabledBlocks();

          btn.classList.remove("loading");
        } catch (error) {
          console.error("Error adding to cart:", error);
          btn.classList.remove("loading");
        }
      });
    }
  },

  clearInputs() {
    const allInputs = document.querySelectorAll("product input:checked");

    for (const input of allInputs) {
      if (input.dataset.defaultOption === "true") continue;
      input.checked = false;

      if (input.dataset.colour && input.closest("product")) {
        const product = input.closest("product");
        const colour = input.dataset.colour;
        if (product.querySelector(`input[data-colour="${colour}"][data-default-option]`)) {
          const defaultInput = product.querySelector(`input[data-colour="${colour}"][data-default-option]`);
          defaultInput.checked = true;
        }
      }
    }

    if (document.querySelector(".global-product__options__subscription")) {
      document.querySelector(".global-product__options__subscription").classList.remove("active");
    }

    if (document.querySelector("[data-default-price]")) {
      for (const priceEl of document.querySelectorAll("[data-default-price]")) {
        if (priceEl.dataset.defaultPrice) {
          priceEl.textContent = priceEl.dataset.defaultPrice;
        }
      }
    }
  },

  watchATCScroll() {
    let currentScroll = window.scrollY;
    let element = document.querySelector(".global-product__atc-bar");

    const checkATCScroll = () => {
      if (window.scrollY > 0) {
        element.classList.remove("scrolled");
      } else {
        element.classList.add("scrolled");
      }

      if (window.scrollY > currentScroll) {
        element.classList.add("show");
      } else {
        element.classList.remove("show");
      }

      currentScroll = window.scrollY;

      const btn = element.querySelector(".btn");
      const productSection = document.querySelector(".global-section-parent.global-product");
      btn.addEventListener("click", (event) => {
        // event.preventDefault();
        document.querySelector("#header").classList.remove("show");
        element.classList.remove("show");
        // productSection.scrollIntoView({ behavior: "smooth" });
      });
    };

    // Run the check immediately on page load
    checkATCScroll();

    // Add the scroll event listener
    document.addEventListener("scroll", checkATCScroll);
  },

  updateFloatingATC() {
    const selectEls = document.querySelectorAll("[data-sticky-selection]");
    const getStartedBtn = document.getElementById("getStartedBtn");
    const getStartedBtnText = getStartedBtn.querySelector("span.text");

    let currentTargetEl = selectEls[0];

    while (currentTargetEl && currentTargetEl.dataset.stickySelection === "selected") {
      const nextIndex = Array.from(selectEls).indexOf(currentTargetEl) + 1;
      currentTargetEl = selectEls[nextIndex] || null;
    }

    // Initially set the button text to the first title
    if (currentTargetEl) {
      getStartedBtnText.textContent = currentTargetEl.dataset.stickySelectionTitle;
    }

    selectEls.forEach((el, index) => {
      el.addEventListener("click", () => {
        const input = el.querySelector("input:checked, input[selected]");
        if (!input) {
          return false;
        }

        if (el.getAttribute("data-selection") === "selected") {
          return false;
        }

        el.setAttribute("data-selection", "selected");

        const nextEl = selectEls[index + 1];
        if (nextEl) {
          // Note: stick to one attribute naming convention
          const nextTitle = nextEl.dataset.stickySelectionTitle || nextEl.dataset.selectionTitle;
          if (nextTitle) {
            getStartedBtnText.textContent = nextTitle;
            currentTargetEl = nextEl; // Update the target element
          }
        }
      });
    });

    getStartedBtn.addEventListener("click", (event) => {
      // event.preventDefault();
      if (!currentTargetEl) return;

      const getStartedText = getStartedBtnText.textContent.trim();

      if (getStartedText === "Add to cart") {
        const addToCartBtn = document.querySelector("[data-product-atc]");
        if (addToCartBtn) {
          addToCartBtn.click(); // Triggers the native click event
        }
      }

      const offset = 51;
      const rect = currentTargetEl.getBoundingClientRect();
      const scrollTop = window.scrollY || window.pageYOffset;
      const targetTop = rect.top + scrollTop - offset;

      const header = document.querySelector("#header");
      let lastScrollTime = Date.now();
      let keepRemoving = true;

      const suppressHeader = () => {
        if (!keepRemoving) return;
        header.classList.remove("show");
        if (Date.now() - lastScrollTime > 500) {
          keepRemoving = false;
          return;
        }
        requestAnimationFrame(suppressHeader);
      };

      const scrollHandler = () => {
        lastScrollTime = Date.now();
        header.classList.remove("show");
      };

      window.addEventListener("scroll", scrollHandler);
      requestAnimationFrame(suppressHeader);

      window.scrollTo({
        top: targetTop,
        behavior: "smooth",
      });

      currentTargetEl.classList.add("Attention");
      setTimeout(() => {
        currentTargetEl.classList.remove("Attention");
      }, 2000);
    });
  },

  resetFloatingATC() {
    const selectEls = document.querySelectorAll("[data-sticky-selection]");
    selectEls.forEach((el) => {
      el.setAttribute("data-sticky-selection", "");
      el.setAttribute("data-selection", "");
    });
    this.updateFloatingATC();
  },

  initIntelligems() {
    const waitForIntelligems = () => {
      return new Promise((resolve) => {
        const checkExist = setInterval(() => {
          if (window.igData && Object.keys(window.igData).length > 0) {
            clearInterval(checkExist);
            resolve();
          }
        }, 100);
      });
    }

    waitForIntelligems().then(() => {
      if (window.igData) {

        // Update data-price and data-compare-price strings where data-ig-datatags is equal to the variant ID 
        const igDataTags = document.querySelectorAll("[data-ig-datatags]");
        
        igDataTags.forEach((tag) => {
          const id = tag.dataset.igDatatags;
          const price = window.igData?.price?.getPriceByVariantId(id) * 100;
          const comparePrice = window.igData?.price?.getComparePriceByVariantId(id) * 100;
          if (price && price > 0) {
            tag.setAttribute("data-price", price);
          }
          if (comparePrice && comparePrice > 0) {
            tag.setAttribute("data-compare-price", comparePrice);
          }
        });

        // Update text elements showing prices where the data-ig-pricetext and data-ig-comparetext attributes are set to the variant ID 
        const igPriceTexts = document.querySelectorAll("[data-ig-pricetext]");
        igPriceTexts.forEach((text) => {
          const id = text.dataset.igPricetext;
          const price = window.igData?.price?.getPriceByVariantId(id);
          if (price && price > 0) {
            text.textContent = document.body.getAttribute("data-money-format").replace("{{amount}}", price);
          }
        });

        const igCompareTexts = document.querySelectorAll("[data-ig-comparetext]");
        igCompareTexts.forEach((text) => {
          const id = text.dataset.igComparetext;
          const comparePrice = window.igData?.price?.getComparePriceByVariantId(id);
          if (comparePrice && comparePrice > 0) {
            text.textContent = document.body.getAttribute("data-money-format").replace("{{amount}}", comparePrice);
          }
        });

        const igSavingsTexts = document.querySelectorAll("[data-ig-savingstext]");
        igSavingsTexts.forEach((text) => {
          const id = text.dataset.igSavingstext;
          const price = window.igData?.price?.getPriceByVariantId(id);
          const comparePrice = window.igData?.price?.getComparePriceByVariantId(id);
          const savings = Math.round(((comparePrice - price) / comparePrice) * 100);
          if (savings && savings > 0) {
            text.textContent = `${savings}% OFF`;
          }
        });

      }
    });
  },

  onLoadElements() {
    document.querySelectorAll('[data-loaded="false"]').forEach(el => {
      el.setAttribute('data-loaded', 'true');
    });
    document.querySelectorAll('.not-loaded').forEach(el => {
      el.classList.remove('not-loaded');
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  window.PXUTheme.jsGlobalProduct.init();

  if (document.querySelector(".global-product .shopify-payment-button")) {
    // Get the payment button element
    const paymentButton = document.querySelector(".global-product .shopify-payment-button");
    // Get the target container where the payment button should be moved
    const targetContainer = document.querySelector(".global-product .additional_payment_container");

    // If the container exists, move the payment button into it
    if (targetContainer) {
      targetContainer.appendChild(paymentButton);
    }
  }
});
